module.exports = __webpack_public_path__ + "static/media/desert7.cc9a13a3.png";